let ctx;

export const unlockSound = () => {
  try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); ctx.resume?.(); } catch { ctx = null; }
};

export function feedback(ok) {
  try {
    unlockSound();
    (ok ? [880, 1320] : [240, 150]).forEach((f, i) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = ok ? "sine" : "square";
      o.frequency.value = f;
      o.connect(g); g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.16;
      g.gain.setValueAtTime(0.22, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + (ok ? 0.15 : 0.22));
      o.start(t); o.stop(t + 0.25);
    });
  } catch { /* no audio */ }
  navigator.vibrate?.(ok ? 80 : [140, 70, 140]);
  const d = document.createElement("div");
  d.setAttribute("data-testid", ok ? "qr-flash-ok" : "qr-flash-err");
  d.style.cssText = `position:fixed;inset:0;z-index:9999;pointer-events:none;transition:opacity .7s;background:${ok ? "rgba(16,185,129,.5)" : "rgba(244,63,94,.5)"}`;
  document.body.appendChild(d);
  setTimeout(() => { d.style.opacity = "0"; }, 300);
  setTimeout(() => d.remove(), 1100);
}

export const qrUrl = (code) => `${window.location.origin}/q?c=${encodeURIComponent(code)}`;

export const peekQr = (raw) => {
  let code = (raw || "").trim();
  try { if (code.includes("c=")) code = new URL(code).searchParams.get("c") || code; } catch { /* keep raw */ }
  try { return { code, t: JSON.parse(atob(code.split(".")[2].replace(/-/g, "+").replace(/_/g, "/"))).t }; } catch { return { code, t: "" }; }
};

export const getPos = () => new Promise((res) => {
  if (!navigator.geolocation) return res({});
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude }), () => res({}), { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
});

export const fmtDT = (iso) => {
  const d = new Date(iso);
  const m = ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Korr", "Gush", "Sht", "Tet", "Nën", "Dhj"][d.getMonth()];
  return `${d.getDate()} ${m} ${d.getFullYear()}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
